import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { register, bootstrapUser } from '../../store/slices/authSlice';
import './Auth.css';

const Register = () => {
  const [formData, setFormData] = useState({
    companyName: '',
    email: '',
    password: '',
    password2: '',
    accountType: 'RTL',
    phoneNumber: '',
    taxEIN: '',
    address: {
      line1: '',
      city: '',
      state: '',
      postalCode: '',
    },
  });

  const {
    companyName,
    email,
    password,
    password2,
    accountType,
    phoneNumber,
    taxEIN,
    address,
  } = formData;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { user, isLoading, isError, isSuccess, message, token } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isSuccess && token && !user) {
      dispatch(bootstrapUser());
      navigate('/', { replace: true });
    } else if ((isSuccess && token) || (user && token)) {
      navigate('/', { replace: true });
    }
  }, [isSuccess, user, token, dispatch, navigate]);

  const onChange = (e) => {
    const { name, value } = e.target;
    
    if (name.startsWith('address.')) {
      const addressField = name.split('.')[1];
      setFormData((prevState) => ({
        ...prevState,
        address: {
          ...prevState.address,
          [addressField]: value,
        },
      }));
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();

    if (password !== password2) {
      console.error('Passwords do not match');
      return;
    }

    const userData = {
      companyName,
      email,
      password,
      accountType,
      phoneNumber,
      taxEIN,
      address,
    };

    dispatch(register(userData));
  };

  if (isLoading) {
    return <div className="loading">Loading...</div>;
  }

  return (
    <div className="auth-container">
      <div className="auth-card register-card">
        <h1 className="auth-title">Create Account</h1>
        <p className="auth-subtitle">Join the B2B Marketplace</p>

        <form onSubmit={onSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="accountType">Account Type</label>
            <select
              id="accountType"
              name="accountType"
              value={accountType}
              onChange={onChange}
              required
            >
              <option value="RTL">Retailer</option>
              <option value="WHS">Wholesaler</option>
            </select>
          </div>

          <div className="form-group">
            <label htmlFor="companyName">Company Name</label>
            <input
              type="text"
              id="companyName"
              name="companyName"
              value={companyName}
              placeholder="Enter your company name"
              onChange={onChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              placeholder="Enter your email"
              onChange={onChange}
              required
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                type="password"
                id="password"
                name="password"
                value={password}
                placeholder="Enter password"
                onChange={onChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password2">Confirm Password</label>
              <input
                type="password"
                id="password2"
                name="password2"
                value={password2}
                placeholder="Confirm password"
                onChange={onChange}
                required
              />
            </div>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="phoneNumber">Phone Number</label>
              <input
                type="tel"
                id="phoneNumber"
                name="phoneNumber"
                value={phoneNumber}
                placeholder="Phone number"
                onChange={onChange}
              />
            </div>

            <div className="form-group">
              <label htmlFor="taxEIN">Tax EIN (Optional)</label>
              <input
                type="text"
                id="taxEIN"
                name="taxEIN"
                value={taxEIN}
                placeholder="Tax EIN"
                onChange={onChange}
              />
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="address.line1">Address</label>
            <input
              type="text"
              id="address.line1"
              name="address.line1"
              value={address.line1}
              placeholder="Street address"
              onChange={onChange}
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <input
                type="text"
                name="address.city"
                value={address.city}
                placeholder="City"
                onChange={onChange}
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="address.state"
                value={address.state}
                placeholder="State"
                onChange={onChange}
              />
            </div>

            <div className="form-group">
              <input
                type="text"
                name="address.postalCode"
                value={address.postalCode}
                placeholder="ZIP Code"
                onChange={onChange}
              />
            </div>
          </div>

          {isError && <div className="error-message">{message}</div>}

          <button type="submit" className="auth-button" disabled={isLoading}>
            {isLoading ? 'Creating Account...' : 'Create Account'}
          </button>
        </form>

        <p className="auth-link">
          Already have an account?{' '}
          <Link to="/login">Sign in here</Link>
        </p>
      </div>
    </div>
  );
};

export default Register;